import { IconAgentIcon } from '@coze-arch/bot-icons';
import { IconCozCrossCircle, IconCozScene,IconCozDiamond } from '@coze-arch/coze-design/icons';

//超级管理员账号
export const SUPER_ADMINS = ["15555555555"];

//图片精度配置值
export const globalImageSizeItems =[
    {
      key: 'low',
      label: '低精度',
      value: 0,
      desc: 'fov较大，分辨率为1440×1080，建议用于场景分析、远景采集等智能体。',
    },
    {
      key: 'high',
      label: '高精度',
      value: 4,
      desc: 'fov较小，分辨率为2016*1512，建议用于学习指导、拍照购物等智能体。',
    },
];
  
//智能体启动设置
export const globalInputParmsItems = [
  {
    key: 'text',
    label: '文字',
    value: 'question',
    desc:'来自眼睛端的语音输入。'
  },
  {
    key: 'image',
    label: '图片(首轮传递)',
    value: 'image_first',
    desc:'仅启动时由智能体调用相机拍照。'
  },
];

//智能体类型
export const agentKindList = [
  { key: 'rizon', label: '灵珠智能体', icon: IconAgentIcon },
  { key: 'third', label: '三方智能体', icon: IconCozScene },
  { key: 'local', label: '本地智能体', icon: IconCozDiamond },
];